/**
 * created by lei lei on 2020/5/29
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PublishRankings from'./PublishRankings'
import {permissionCheck} from "../../../../utils";
export default class PublishRankingsComponents extends Component {
    static defaultProps = {}
    static propTypes = {}

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let isAuth = permissionCheck("pms:publishRankings:viewAll");//是否展示发布排行
        if(!isAuth){
            return <div></div>
        }
        return (
            <div className={'PublishRankingsComponents '} style={{width:'100%'}}>
                <PublishRankings/>
            </div>
        )
    }

}